export default "__VITE_ASSET__DoriI1e3__"